import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';

export type TextSettingsParams = {
  headerTitle: SettingsParamType.Text;
  headerDescription: SettingsParamType.Text;
  addToCartButtonText: SettingsParamType.Text;
};

export const textSettingsParams = createSettingsParams<TextSettingsParams>({
  headerTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
  },
  headerDescription: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
  },
  addToCartButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => '',
  },
});
